/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Issue_Unknown_FileInputs */

const en_claim_issue_unknown_file = /** @type {(inputs: Claim_Issue_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file is not the customer's or was not uploaded: add it again.`)
};

/**
* | output |
* | --- |
* | "A file is not the customer's or was not uploaded: add it again." |
*
* @param {Claim_Issue_Unknown_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_unknown_file = /** @type {((inputs?: Claim_Issue_Unknown_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_Unknown_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_unknown_file(inputs)
});